// 验证手机号码格式
var validatePhone = function(rule, value, callback) {
	const phoneReg = /^[1][3-9]\d{9}$/; // 中国手机号正则表达式
	if (!value || phoneReg.test(value)) {
		callback();
	} else {
		callback(new Error());
	}
}

// 验证邮编格式
var validateZipcode = function(rule, value, callback) {
	const zipcodeReg = /^[1-9]\d{5}$/; // 中国邮编正则表达式
	if (!value || zipcodeReg.test(value)) {
	  callback();
	} else {
		callback(new Error());
	}
}

var rules = {
	gift_name: [
		{ required: true, message: "请选择产品", trigger: "change" }
	],
	order_no: [
		{ required: true, message: "请输入订单号", trigger: "blur" }
	],
	img_url: [
		{ required: true, message: "请上传图片", trigger: "blur" }
	],
	name: [
		{ required: true, message: "请输入姓名", trigger: "blur" }
	],
	phone: [
		{ required: true, message: "请输入手机号码", trigger: "blur"},
		{ validator: validatePhone, message: '请输入有效的手机号码', trigger: 'blur' }
	],
	
	area: [
		{ required: true, message: "请选择地区", trigger: "change" }
	],
	address: [
		{ required: true, message: "请输入详细地址", trigger: "blur" }
	],
	postcode: [
		{ required: true, message: "请输入邮编", trigger: "blur" },
		{ validator: validateZipcode, message: '请输入有效的邮编', trigger: 'blur'}
	],
}

export { rules }